"use strict";

(function () {
	function r(e, n, t) {
		function o(i, f) {
			if (!n[i]) {
				if (!e[i]) {
					var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
				}var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
					var n = e[i][1][r];return o(n || r);
				}, p, p.exports, r, e, n, t);
			}return n[i].exports;
		}for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
			o(t[i]);
		}return o;
	}return r;
})()({ 1: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				counterWrapper: $('.js-counter')
			},

			classes: {
				open: 'open'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;
				$('.js-counter').each(function (index, el) {
					$(el).prop('Counter', 0).animate({
						Counter: $(el).text()
					}, {
						duration: 1000,
						easing: 'swing',
						step: function step(now) {
							$(el).text(Math.ceil(now));
						}
					});
				});
			}
		};
	}, { "./global": 3 }], 2: [function (require, module, exports) {
		"use strict";

		var Global = require('./global'); // require Global only if you need it
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				contactBtn: $('.js-contact'),
				formBtn: $('.js-form-btn'),
				forms: $('.form-container')
			},

			classes: {
				contactActive: 'js-contact-active'
			},

			attr: {
				exampleDataAttr: 'data-something'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;
				var attr = this.attr;
				var ww = Global.vars.windowWidth; // this variable is called from global.js file

				// bind events

				$('.js-close-form').on('click', function () {
					$('.form-container').removeClass(classes.contactActive);
					Global.$dom.body.css('overflow', 'visible');
				});

				$dom.formBtn.on('click', function () {
					var attr = $(this).attr('data-form');
					var titleAttr = $(this).find('a').attr('title');

					var forms = $dom.forms;
					for (var i = 0; i < forms.length; i++) {
						var formAttr = forms[i].getAttribute('data-form');
						if (formAttr === attr || formAttr === titleAttr) {
							$(forms[i]).addClass('js-contact-active');
							Global.$dom.body.css('overflow', 'hidden');
						}
					}
				});

				$('.wpcf7-submit').on('click', function () {
					var _this = this;

					setTimeout(function () {
						if ($(_this).closest('.wpcf7-form').hasClass('sent')) {
							$(_this).closest('.wpcf7-form').css('display', 'none');
							$(_this).closest('.form-container').find('.form-confirm').css('display', 'block');
						}
					}, 1500);
				});

				var fileName = function fileName(inputName) {
					$(inputName).parents('.form-attachment').find('label').append('<span class="js-attached-file-name attached-file-name"></span>');
					$(inputName).on('change', function () {
						var files = $(inputName)[0].files;

						// empty label span if file is removed
						if (files.length < 1) {
							$(this).parents('.form-attachment').find('.js-attached-file-name').text('');
						}

						for (var i = 0; i < files.length; i++) {
							$(this).parents('.form-attachment').find('.js-attached-file-name').text(': ' + files[i].name);
						}
					});
				};

				fileName('#resume');
				fileName('#coverLetter');

				var formVaidate = function formVaidate() {
					var submit = $('.wpcf7-submit');
					var inputFile = $('input[type="file"]');

					submit.on('click', function () {
						setTimeout(function () {
							inputFile.each(function (i, el) {
								if ($(el).hasClass('wpcf7-not-valid')) {
									$(el).parents('.form-attachment').find('label').addClass('wpcf7-not-valid-label');
								} else {
									$(el).parents('.form-attachment').find('label').removeClass('wpcf7-not-valid-label');
								}
							});
						}, 500);
					});
				};

				formVaidate();
			}
		};
	}, { "./global": 3 }], 3: [function (require, module, exports) {
		"use strict";

		module.exports = {
			$dom: {
				window: $('window'),
				body: $('body')
			},

			vars: {
				windowWidth: window.innerWidth
			},

			functions: {
				escKey: function escKey(callback) {
					$(document).on('keyup', function (e) {
						if (e.keyCode === 27) {
							callback();
						}
					});
				},

				clickOutsideContainer: function clickOutsideContainer(selector, container, closeBtn, callback) {
					selector.on('mouseup', function (e) {
						e.preventDefault();
						if (!container.is(e.target) && container.has(e.target).length === 0 && !closeBtn.is(e.target)) {
							callback();
						}
					});
				}
			}
		};
	}, {}], 4: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				menuBtn: $('.js-menu-btn'),
				menuNav: $('.js-main-nav'),
				menuHasSub: $('.menu-item-has-children')
			},

			classes: {
				open: 'open',
				openMenu: 'menu-open'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;

				// functions
				function closeNav() {
					$dom.menuBtn.removeClass(classes.open);
					$dom.menuNav.removeClass(classes.open);
					Global.$dom.body.removeClass(classes.openMenu);
				}

				if (Global.vars.windowWidth < 1199) {
					$dom.menuHasSub.each(function (i, el) {
						$(el).append('<span class="sub-icon font-plus-circle" data-open-sub></span>');
					});
				}

				// bind events
				$dom.menuBtn.on('click', function (e) {
					e.preventDefault();
					// $dom.menuBtn.toggleClass(classes.open);
					// $dom.menuNav.toggleClass(classes.open);
					// Global.$dom.body.toggleClass(classes.openMenu);
					$(this).toggleClass('js-btn-active');
					$(this).toggleClass('font-chevron-down');
					$(this).toggleClass('font-chevron-up');
					$(this).parent().find('#site-navigation').slideToggle('fast');
					if ($(this).hasClass('js-btn-active')) {
						$(this).find('.menu-btn-text').text('Close');
					} else {
						$(this).find('.menu-btn-text').text('Menu');
					}
				});
				$('.nav-item-mobile>a').on('click', function () {
					if (Global.vars.windowWidth < 1199) {
						$('.site-header__wrap').find('.menu-btn').click();
					}
				});
				$dom.menuNav.on('click', '[data-open-sub]', function () {
					if (Global.vars.windowWidth < 1199) {
						$(this).siblings('.sub-menu').slideToggle();
					}
				});
				$('.footer-btn').click(function () {
					$('html,body').animate({ scrollTop: 0 }, 'slow');
					return false;
				});

				Global.functions.clickOutsideContainer($dom.menuNav, $dom.menuNav.children('ul'), $dom.menuBtn, closeNav);

				Global.functions.escKey(closeNav);

				$(window).scroll(function () {
					if (Global.vars.windowWidth > 1199) {
						var y = $(this).scrollTop();
						if (y > 200) {
							$('.site-branding').addClass('rotate-logo');
						} else {
							$('.site-branding').removeClass('rotate-logo');
						}
					}
				});
			}
		};
	}, { "./global": 3 }], 5: [function (require, module, exports) {
		'use strict';

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				parallaxImgContainer: $('.js-parallax-img'),
				parallaxBgContainer: $('.js-parallax-bg')
			},

			classes: {
				contactActive: 'js-contact-active'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;
				var ww = Global.vars.windowWidth;

				if (ww > 1199) {
					// Fix for parallax bg
					// each img wrapper add img src as background
					$dom.parallaxImgContainer.each(function () {
						var $container = $(this);

						var imgUrl = $container.find('img').prop('src');
						var imgClass = $container.find('img').attr('class');
						if (imgUrl) {
							$container.css('backgroundImage', 'url(' + imgUrl + ')').addClass(imgClass);
						}
					});

					$(window).on('scroll', function () {
						// Parallax bg
						$dom.parallaxBgContainer.each(function (index, el) {
							var elementOffsetParallax = $(el).offset().left;
							var percMulti = (window.innerWidth - elementOffsetParallax) / 20;
							var percFinal = 100 - percMulti;
							var percZoom = 130 - (window.innerWidth - elementOffsetParallax) / 100;
							if (percZoom <= 110) {
								percZoom = 110;
							}

							// only perform parallax if ilement is in viewport for better scroll performance
							if (elementOffsetParallax <= window.innerWidth && elementOffsetParallax + window.innerWidth + $(el).width() + 250 >= window.innerWidth) {
								$(el).css({
									'background-position': percFinal + "%, 50%"
									// 'background-size': `${percZoom}%`
								});
							}
						});
					});

					// Parallax bg
					// $('.js-parallax-bg').each(function (index, el) {
					// 	const elementOffsetParallax = $(el).offset().left;
					// 	const percMulti = (window.innerWidth - elementOffsetParallax) / 25;
					// 	let percZoom = 130 - ((window.innerWidth - elementOffsetParallax) / 100);
					// 	// console.log(percZoom, (window.innerWidth - elementOffsetParallax) / 140);
					// 	if (percZoom <= 110) {
					// 		percZoom = 110;
					// 	}
					// 	// console.log($('.article-img-wrap').offset().left, $('.article-img-wrap').offset().left + window.innerWidth + $('.article-img-wrap').width());

					// 	// only perform parallax if ilement is in viewport for better scroll performance
					// 	if (elementOffsetParallax <= window.innerWidth && (elementOffsetParallax + window.innerWidth + $(el).width() + 250) >= window.innerWidth) {
					// 		$(el).css({
					// 			'background-position': `${percMulti}%, 50%`,
					// 			// 'background-size': `${percZoom}%`
					// 		});
					// 	}
					// });

					// $('.js-parallax-img img').each(function (index, el) {
					// 	const elementOffsetParallax = $(el).offset().left;
					// 	const percMulti = (window.innerWidth - elementOffsetParallax) / 40;
					// 	let percScale = 1.1 - (percent / 10);

					// 	const percScale = 1.15;

					// 	if (elementOffsetParallax <= window.innerWidth) {
					// 		$(el).css({
					// 			// 'transform': `translateX(${percMulti}px) scale(${percScale})`,
					// 			'transform': `translateX(${percMulti}px) scale(${percScale})`,

					// 		});
					// 	}
					// });
				} else {
					$dom.parallaxImgContainer.find('img').unwrap();
				}
			}
		};
	}, { "./global": 3 }], 6: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				slider: $('.banner-wrap')
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var ww = Global.vars.windowWidth;
				// slider
				if (ww < 1200) {
					$dom.slider.slick({
						infinite: true,
						slidesToShow: 1,
						slidesToScroll: 1,
						speed: 1000,
						arrows: false,
						autoplay: true,
						autoplaySpeed: 4000
					});
				}
			}
		};
	}, { "./global": 3 }], 7: [function (require, module, exports) {
		"use strict";

		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				contactBtn: $('.js-contact'),
				formBtn: $('.js-form-btn'),
				forms: $('.form-container')
			},

			classes: {
				contactActive: 'js-contact-active'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;

				var $window = $(window);
				var scrollTime = 1;
				var scrollDistance = 400;

				$window.on("mousewheel DOMMouseScroll", function (event) {
					if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1 || navigator.userAgent.indexOf("Chrome") != -1) {

						event.preventDefault();

						var delta = event.originalEvent.wheelDelta / 60 || -event.originalEvent.detail / 3;
						var scrollTop = $window.scrollTop();
						var finalScroll = scrollTop - parseInt(delta * scrollDistance);

						TweenMax.to($window, scrollTime, {
							scrollTo: { y: finalScroll, autoKill: false },
							ease: Power1.easeOut,
							overwrite: 1
						});
					}
				});
			}
		};
	}, {}], 8: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				header: $('.site-header')
			},

			vars: {
				headerOffset: 90
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var vars = this.vars;
				var ww = Global.vars.windowWidth;
				function stickyHeader() {
					if (ww < 1999) {
						if (window.pageYOffset >= vars.headerOffset) {
							$dom.header.addClass('sticky');
						} else {
							$dom.header.removeClass('sticky');
						};
					}
				}
				window.onscroll = function () {
					stickyHeader();
				};
			}
		};
	}, { "./global": 3 }], 9: [function (require, module, exports) {
		"use strict";

		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				contactBtn: $('.js-contact'),
				formBtn: $('.js-form-btn'),
				forms: $('.form-container')
			},

			classes: {
				contactActive: 'js-contact-active'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;

				var svgScrollFunction = function svgScrollFunction(svgClass, offset, multiply) {
					$(window).scroll(function () {
						if ($(svgClass).length) {
							var path = document.querySelector(svgClass);
							var pathLength = path.getTotalLength();

							// Make very long dashes (the length of the path itself)
							path.style.strokeDasharray = pathLength + ' ' + pathLength;

							// Offset the dashes so the it appears hidden entirely
							path.style.strokeDashoffset = 0;
							path.getBoundingClientRect();

							// When the page scrolls...
							window.addEventListener("scroll", function (e) {

								// var scrollPercentage = (document.documentElement.scrollTop + document.body.scrollTop) / (document.documentElement.scrollHeight - document.documentElement.clientHeight);

								// if ($(svgClass).offset().left < window.innerWidth) {
								// 	var scrollPercentageNew = document.documentElement.scrollTop / ((window.innerWidth * offset) + $(svgClass).offset().left + document.documentElement.scrollTop);
								// 	// console.log(scrollPercentageNew);
								// 	$('.svg-track').addClass('show');
								// }

								// IE Fix/ cross browser
								if ($(svgClass).offset().left < window.innerWidth) {
									var scrollPercentageNew = window.pageYOffset / (window.innerWidth * offset + $(svgClass).offset().left + window.pageYOffset);
									$('.svg-track').addClass('show');
								}

								// Length to offset the dashes
								var drawLength = pathLength * scrollPercentageNew;

								// Draw in reverse
								path.style.strokeDashoffset = 0 - drawLength * multiply;

								// When complete, remove the dash array, otherwise shape isn't quite sharp
								// Accounts for fuzzy math
								if (scrollPercentageNew >= 0.99) {
									path.style.strokeDasharray = pathLength;
								} else {
									path.style.strokeDasharray = pathLength + ' ' + pathLength;
								}
							});
						}
					});
				};

				svgScrollFunction('.dashed', 1.5, 1.7);
				svgScrollFunction('.dashed-service', 1.2, 1.4);

				if (window.innerWidth < 1450) {
					svgScrollFunction('.dashed-service', 1.2, 1.1);
				}
			}
		};
	}, {}], 10: [function (require, module, exports) {
		"use strict";

		var Global = require('./global'); // require Global only if you need it
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				tabItem: $('.our-team-section-tab-item'),
				tabItemText: $('.tab-item-text'),
				tabItemImage: $('.owner-image')
			},

			classes: {
				tabActive: 'js-tab-item-active',
				textActive: 'js-tab-item-text-active',
				imageActive: 'js-owner-image-active'
			},

			attr: {
				owner: 'data-owner-name'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;
				var attr = this.attr;
				var ww = Global.vars.windowWidth; // this variable is called from global.js file

				// bind events
				var updateAll = function updateAll(attribute) {
					// update tab header name
					$dom.tabItem.removeClass(classes.tabActive);

					for (var i = 0; i < $dom.tabItem.length; i++) {
						if ($dom.tabItem[i].getAttribute('data-owner-name') === attribute) {
							$dom.tabItem[i].classList.add(classes.tabActive);
						}
					}
					// update text in tab
					$dom.tabItemText.removeClass(classes.textActive);
					for (var j = 0; j < $dom.tabItemText.length; j++) {
						if ($dom.tabItemText[j].getAttribute('data-owner-name') === attribute) {
							$dom.tabItemText[j].classList.add(classes.textActive);
						}
					}
					// update picture
					$dom.tabItemImage.removeClass(classes.imageActive);
					for (var k = 0; k < $dom.tabItemImage.length; k++) {
						if ($dom.tabItemImage[k].getAttribute('data-owner-name') === attribute) {
							$dom.tabItemImage[k].classList.add(classes.imageActive);
						}
					}
				};

				$dom.tabItem.on('click', function () {
					var attr = $(this).attr('data-owner-name');
					updateAll(attr);
				});

				$dom.tabItemImage.on('click', function () {
					var attr = $(this).attr('data-owner-name');
					updateAll(attr);
				});
			}
		};
	}, { "./global": 3 }], 11: [function (require, module, exports) {
		'use strict';

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				hsCont: $('.js-hs-container'),
				hs: $('.js-hs'),
				motionCity: $('.illustration-city-motion'),
				motionCitySrc: $('.illustration-city-motion').attr('src')
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				this.setContainerWidth();
				this.initHS();
			},

			initHS: function initHS() {

				var ww = Global.vars.windowWidth;
				if (ww > 1199) {
					var $dom = this.$dom;
					var gifAnimated = false;

					$.jInvertScroll(['.js-hs-container'], {
						onScroll: function onScroll(percent) {
							// On Scroll animate elements
							// Every element which we want to animate on entering viewport should have this class
							var animationElement = $('.js-animated');
							animationElement.each(function (index, el) {
								var elementOffset = $(el).offset().left + $(el).width() / 1.5;
								// const windowWidth = window.innerWidth;

								if (elementOffset <= window.innerWidth) {
									$(el).addClass('animate-element');
								}

								if ($('.illustration-img-wrap').hasClass('animate-element') && gifAnimated === false) {
									$('.illustration-city').css('display', 'none');
									$('.illustration-city-motion').attr('src', $dom.motionCitySrc);
									gifAnimated = true;
								}
							});
						}
					});

					$('.illustration-img-wrap').on('classChange', function () {
						console.log('aaa');
					});
				}
			},

			setContainerWidth: function setContainerWidth() {
				var $dom = this.$dom;
				var width = 0;

				$dom.hs.each(function (i, el) {
					// added 0.5px to fix last section dissapearing
					width += $(el).outerWidth() + 0.5;
				});

				$dom.hsCont.css('width', width + "px");

				return width;
			}
		};
	}, { "./global": 3 }], 12: [function (require, module, exports) {
		jQuery(function ($) {
			// Site Menu
			var menu = require('./_site/menu');
			menu.init();

			// Slick Slider
			var sliders = require('./_site/sliders');
			sliders.init();

			// Vertical Scroll
			var verticalScroll = require('./_site/verticalScroll');
			verticalScroll.init();

			// Vertical Scroll
			var svgScroll = require('./_site/svg-scroll');
			if (window.innerWidth > 1199) {
				svgScroll.init();
			}

			// Counter
			var counter = require('./_site/counter');
			counter.init();

			// Tabs / Img switcher
			var tabs = require('./_site/tabs');
			tabs.init();

			// Form sliders
			var forms = require('./_site/forms');
			forms.init();

			// Sticky Header
			var stickyHeader = require('./_site/stickyHeader');
			stickyHeader.init();

			// Sticky Header
			var parallax = require('./_site/parallax');
			parallax.init();

			// Sticky Header
			if (window.innerWidth > 1200) {
				var smoothScrollPage = require('./_site/smooth-scroll');
				smoothScrollPage.init();
			}
		});
	}, { "./_site/counter": 1, "./_site/forms": 2, "./_site/menu": 4, "./_site/parallax": 5, "./_site/sliders": 6, "./_site/smooth-scroll": 7, "./_site/stickyHeader": 8, "./_site/svg-scroll": 9, "./_site/tabs": 10, "./_site/verticalScroll": 11 }] }, {}, [12]);